module.exports = __webpack_public_path__ + "img/method-not-found.8aabd378.png";